import { render } from "./house-tag.vue?vue&type=template&id=902b883e"
import script from "./house-tag.vue?vue&type=script&lang=js"
export * from "./house-tag.vue?vue&type=script&lang=js"

import "./house-tag.vue?vue&type=style&index=0&id=902b883e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-house/_component/house-tag.vue'],['render',render],['__file',"house-tag.vue"]])

export default __exports__